import React from 'react'
import PropTypes from 'prop-types'
import { Form } from '../../common/form/Form'

/**
 * ProfileUpdate Component
 *
 * A React component that provides a form for updating the user's profile. It utilizes a `Form` component with specific props to handle profile updates.
 *
 * @module profile/ProfileUpdate
 * @description A React component that provides a form for updating the user's profile. It utilizes a `Form` component with specific props to handle profile updates.
 * @param {Object} authDetails - Authentication details including user information.
 * @param {Object} moduleSchema - Schema object for the module, including form schema for updates.
 * @param {string} isLocalEnvironment - Flag indicating whether the environment is local.
 * @param {Object} envData - Environment data object.
 * @param {Object} authDetails.session - Session details object.
 * @param {Object} authDetails.session.user - User details object in session.
 * @param {Object[]} authDetails.session.user.UserFamily - Array of user family objects.
 * @param {Object} moduleSchema.form.update - Schema for the update form.
 *
 * @example
 * const authDetails = {
 *   session: {
 *     user: {
 *       UserFamily: [
 *         { name: 'John Doe', email: 'john@example.com' }
 *       ]
 *     }
 *   }
 * };
 * const moduleSchema = {
 *   form: {
 *     update: { form schema here }
 *   }
 * };
 * const isLocalEnvironment = 'true';
 * const envData = { environment data here };
 *
 * return (
 *   <ProfileUpdate
 *     authDetails={authDetails}
 *     moduleSchema={moduleSchema}
 *     isLocalEnvironment={isLocalEnvironment}
 *     envData={envData}
 *   />
 * );
 *
 * @returns {React.Element} The rendered component containing the profile update form.
 */
export const ProfileUpdate = ({ authDetails, moduleSchema, isLocalEnvironment, envData }) => {
  return (
    <div className="trtui-card trtui-mt-xxl-n5">
      <div className="trtui-card-header">Edit Profile</div>
      <div className="trtui-card-body trtui-p-4">
        <div className="trtui-tab-content">
          <div className="trtui-tab-pane trtui-active" role="tabpanel">
            <Form
              authDetails={authDetails}
              defaultData={authDetails.session?.user?.UserFamily[0]}
              formSchema={moduleSchema.form.update}
              addUserObject={true}
              isUpdate={true}
              isProfile={true}
              moduleSchema={moduleSchema}
              isLocalEnvironment={isLocalEnvironment}
              envData={envData}
              crud={3}
              noClose={true}
            />
          </div>
        </div>
      </div>
    </div>
  )
}

ProfileUpdate.propTypes = {
  authDetails: PropTypes.object.isRequired,
  moduleSchema: PropTypes.object.isRequired,
  isLocalEnvironment: PropTypes.string.isRequired,
  envData: PropTypes.object.isRequired,
}
